"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ProfileHomeWrapper = function ProfileHomeWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  var ProfileHome = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function ProfileHome(_props) {
      var _this;
      _classCallCheck(this, ProfileHome);
      _this = _callSuper(this, ProfileHome, [_props]);
      _initializerDefineProperty(_this, "selectedUserId", _descriptor, _this);
      _initializerDefineProperty(_this, "expandFeed", _descriptor2, _this);
      _this.userIdFromPropsForProps = function (props) {
        return _state.AppUI.layout.isNative ? props.route && props.route.params ? props.route.params.userId : null : props.params ? props.params.userId : null;
      };
      _this.getUser = function () {
        if (_this.userIdFromProps !== _this.selectedUserId) {
          _this.selectedUserId = _state.AppUI.layout.isNative ? _this.userIdFromProps : _this.props.params ? _this.userIdFromProps : null;
          if (_this.userIsMe) {
            _state.AppUI.userStore.clearShowData();
          } else if (_this.userId) {
            _state.AppUI.userStore.getShow({
              ids: {
                userId: _this.userId
              }
            });
          }
        }
      };
      _this.onToggleFollowing = function () {
        if (_this.user.followAssociationId) {
          _state.AppUI.followAssociationStore.destroy({
            ids: {
              followAssociationId: _this.user.followAssociationId
            }
          }, _lodash.noop);
          _this.user.set('followAssociationId', null);
          _state.AppUI.user.set('followingsCount', _state.AppUI.user.followingsCount - 1);
        } else {
          _state.AppUI.followAssociationStore.create({
            data: {
              follower_id: _state.AppUI.user.id,
              user_id: _this.user.id
            }
          }, _this.afterCreateFollowing);
          _this.user.set('followAssociationId', 99);
        }
      };
      _this.afterCreateFollowing = function (resp) {
        _this.user.set('followAssociationId', resp['followAssociationId']);
        _state.AppUI.user.set('followingsCount', _state.AppUI.user.followingsCount + 1);
      };
      _this.setExpandFeed = function (expandFeed) {
        _this.expandFeed = expandFeed;
      };
      _this.onDestroyFeedEntry = function (id) {
        _state.AppUI.feedEntryStore.destroy({
          ids: {
            feedEntryId: id
          }
        }, _this.afterChange);
      };
      _this.afterChange = function () {
        _state.AppUI.feedEntryStore.reloadIndexFiltered();
      };
      _state.AppUI.userStore.clearShowData();
      _this.getUser();
      return _this;
    }
    _inherits(ProfileHome, _React$Component);
    return _createClass(ProfileHome, [{
      key: "userId",
      get: function get() {
        return this.selectedUserId || _state.AppUI.user.id;
      }
    }, {
      key: "userIdFromProps",
      get: function get() {
        return this.userIdFromPropsForProps(this.props);
      }
    }, {
      key: "userIsMe",
      get: function get() {
        return !(0, _utils.isPresent)(this.userId) || "".concat(this.userId) === "".concat(_state.AppUI.user.id);
      }
    }, {
      key: "user",
      get: function get() {
        if (this.userIsMe) {
          return _state.AppUI.user && "".concat(_state.AppUI.user.id) === "".concat(this.userId) ? _state.AppUI.user : null;
        }
        return _state.AppUI.userStore.showData && "".concat(_state.AppUI.userStore.showData.id) === "".concat(this.userId) ? _state.AppUI.userStore.showData : null;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.userIdFromPropsForProps(prevProps) !== this.userIdFromProps) {
          this.getUser();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.userStore.clearShowData();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          selectedUserId: this.selectedUserId,
          userId: this.userId,
          userIsMe: this.userIsMe,
          user: this.user,
          getUser: this.getUser,
          onToggleFollowing: this.onToggleFollowing,
          afterCreateFollowing: this.afterCreateFollowing,
          expandFeed: this.expandFeed,
          setExpandFeed: this.setExpandFeed,
          afterChange: this.afterChange
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedUserId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "expandFeed", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "userId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userIdFromProps", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userIdFromProps"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userIsMe", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userIsMe"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "user"), _class2.prototype), _class2)) || _class;
  return ProfileHome;
};
ProfileHomeWrapper.displayName = 'ProfileHomeWrapper';
var _default = exports["default"] = ProfileHomeWrapper;